import * as t from "io-ts";
import { filterObj } from "ui-lib";
// import javaTimeFormat from "../java-time-format";
import fetchApi from "../fetch-api";
import { getQueryPath } from "../get-query-path";
import { CompaniesIO } from "../company-io";
import PaginatedResponseIO from "../api";
// type FilterT = {
//   id: number;
//   field: string;
//   condition: string;
//   value: string | number | string[];
//   logic?: "AND" | "OR";
//   // pickerMode?: "year" | "month";
// };

type FilterT = { [key: string]: { condition?: string; value: any } };
type Query = {
  filterObject?: FilterT;
  latestRegistered?: boolean;
  pageSize?: number;
  page?: number;
};

export const CompanySearchResultIO = PaginatedResponseIO(CompaniesIO);
export type CompanyResultT = t.TypeOf<typeof CompanySearchResultIO>;
export const DEFAULT_PAGE_SIZE = 30;

export const companiesMutation = ({
  filterObject,
  pageSize,
  ...query
}: Query) => {
  const filteredObj = filterObj(
    {
      limit: pageSize && pageSize,
      ...query,
    },
    (_, value: any) => value !== undefined
  );

  const currentObject = Object.fromEntries(
    Object.entries(filteredObj).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.join(",") : value,
    ])
  );

  const queryPath = getQueryPath({ ...currentObject });
  return fetchApi({
    service: "core-service",
    method: "POST",
    pathname: `/filterd-companies?${queryPath}`,
    body: filterObject,
    codec: CompanySearchResultIO,
  });
};